import { baseApi } from 'components/constants/Constants';
import { useAxiosWithAuth } from './useAxios';
import { SegmentTag } from 'types/global';
import { CompanyTypes } from 'api/types/ReferenceDataTS';

export type ValidateReponse = {
  email: string;
  company:
    | {
        key: string;
        name: string;
        type: CompanyTypes;
      }
    | undefined;
};

export enum ValidateErrorType {
  EVENT_USER_ALREADY_EXISTS = 'EVENT_USER_ALREADY_EXISTS',
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
  INVALID_EMAIL = 'INVALID_EMAIL'
}

export type ValidateError = {
  additional_data: {
    event: {
      event: string;
    };
    type: string;
    email: string;
  };
  title: ValidateErrorType;
  status: number;
  detail: string;
};

export const useValidate = (eventKey: string) => {
  return useAxiosWithAuth<ValidateReponse>(
    {
      url: eventKey
        ? `${baseApi}/registration/portals/${eventKey}/validate`
        : `${baseApi}/registration/validate`,
      method: 'POST'
    },
    {
      manual: true
    }
  );
};

export type SignupResponse = object;
export type SignupInput = {
  password: string;
  email: string;
  firstname: string;
  lastname: string;
  department: string;
  country_code: string;
  terms_accepted: boolean;
  event_terms_accepted?: boolean;
  job_title?: string;
  segment?: SegmentTag;
  notifications?: {
    covalo_digest_enabled: boolean;
  };
  phone_number: string;
  // If specified the user will be assigned to the staging company
  special_case?: {
    company_name: string;
    user_notes: string;
    company_type: CompanyTypes | '';
  };
};

export const useSignup = (eventKey: string) => {
  return useAxiosWithAuth<SignupResponse, SignupInput>(
    {
      url: eventKey
        ? `${baseApi}/registration/portals/${eventKey}/signup`
        : `${baseApi}/registration/signup`,
      method: 'POST'
    },
    {
      manual: true
    }
  );
};

export const useSignupExisting = (eventKey: string) => {
  return useAxiosWithAuth(
    {
      url: `${baseApi}/portals/${eventKey}/users/signup`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: {
        event_terms_accepted: true
      }
    },
    {
      manual: true
    }
  );
};

/**
 * Use with the params
 *
 * @param registration
 * @param activation
 */
export const useActivate = () => {
  return useAxiosWithAuth(
    {
      url: `${baseApi}/registration/activate`,
      method: 'POST'
    },
    {
      manual: true
    }
  );
};
